export default "__VITE_ASSET__e222709d__"